// src/components/Sidebar.tsx
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "@assets/images/LOGO_MPS.png";
import Dashboard from "@components/icones/dashboard.tsx";
import Setting from "@components/icones/setting.tsx";
import Plainte from "@components/icones/plainte.tsx";
import ArrowRight from "@components/icones/arrowRight.tsx";
import { useMenu } from "@components/MenuContext.tsx";
import { useAppDispatch, useAppSelector } from "@core/store/hook.ts";
import { userConnected } from "@core/slice/UsersSlice.ts";
import { getUserConnectedDetail } from "@core/actions/usersActions.ts";
import { TypeProfil } from "@modules/plaintes/plaintes.model.ts";

const Sidebar: React.FC = () => {
  const dispatch = useAppDispatch();
  const detailsUserConnected = useAppSelector(userConnected);
  const location = useLocation();
  // const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState<string | null>(null);
  const { setTitle } = useMenu();
  const isUserManagementActive =
    location.pathname === "/setting/add-user" ||
    location.pathname === "/setting/list-user";


  React.useEffect(() => {
    dispatch(getUserConnectedDetail());
  }, [dispatch]);

  React.useEffect(() => {
    const isComplaint = location.pathname.split("/").includes("complaint");
    if (isComplaint) {
      setTitle("Gestion des plaintes");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const normalizeText = (text: string) => text.trim().toLowerCase();

  const isDashboard = detailsUserConnected?.profil.permissions.find(
    (p: any) => normalizeText(p.name) === normalizeText("dashboard")
  );

  const isAdmin = detailsUserConnected?.profil.permissions.find((p: any) =>
    normalizeText(p.name) === normalizeText("parametre")
  );

  const isSuperAdmin = detailsUserConnected?.profil?.type === TypeProfil.ADMIN;

  const isComplaint = detailsUserConnected?.profil.permissions.find(
    (p: any) => normalizeText(p.name) === normalizeText("plaintes")
  );

  return (
    <aside className="">
      {/* Logo */}
      <div className="sidebar fixed left-0 top-0 h-full w-72 bg-[#FFFFFF] text-gray shadow-lg">
        <div>
          <div className="flex items-center justify-center my-[30px]">
            <img src={logo} alt="Logo" className="w-32 h-auto" />
          </div>

          {/* Menu */}
          <nav className="flex flex-col mt-4">
            {isDashboard && (
              <Link
                to="/"
                className={`pl-6 menu ${
                  location.pathname === "/" ? "menu-active" : ""
                }`}
                onClick={() => {
                  setTitle("Tableau de bord");
                  setIsMenuOpen((prev) =>
                    prev === "dashbord" ? null : "dashbord"
                  );
                }}
              >
                <span className="pr-2">
                  <Dashboard
                    color={location.pathname === "/" ? "#086D33" : "#6C757D"}
                  />
                </span>
                Tableau de bord
              </Link>
            )}
            {isAdmin && (
              <div
                className={`pl-6 pr-3 menu ${
                  isMenuOpen === "setting" ? "menu-active" : ""
                } flex justify-between items-center`}
                onClick={() => {
                  setIsMenuOpen((prev) =>
                    prev === "setting" ? null : "setting"
                  );
                  // navigate("/setting/data");
                }}
                style={{ cursor: "pointer" }}
              >
                <div className="flex items-center">
                  <span className="pr-2">
                    <Setting
                      color={isMenuOpen === "setting" ? "#086D33" : "#6C757D"}
                    />
                  </span>
                  Paramètres
                </div>
                {/* Flèche */}
                <span
                  className={`transition-transform ${
                    isMenuOpen ? "rotate-90" : "rotate-0"
                  }`}
                >
                  <ArrowRight
                    color={isMenuOpen === "setting" ? "#086D33" : "#6C757D"}
                  />
                </span>
              </div>
            )}

            {isMenuOpen === "setting" && (
              <div>
                {/* <Link
                  to="/setting/data"
                  className={`pl-[3.8rem] block menu ${
                    location.pathname === "/setting/data"
                      ? "submenu-active"
                      : ""
                  }`}
                  onClick={() => setTitle("Gestion des données")}
                >
                  Gestion des données
                </Link> */}
                <Link
                  to="/setting/list-user"
                  className={`pl-[3.8rem] block menu ${
                    isUserManagementActive ? "submenu-active" : ""
                  }`}
                  onClick={() => setTitle("Gestion des utilisateurs")}
                >
                  Gestion des utilisateurs
                </Link>
                <Link
                  to="/setting/group"
                  className={`pl-[3.8rem] block menu ${
                    location.pathname === "/setting/group"
                      ? "submenu-active"
                      : ""
                  }`}
                  onClick={() => setTitle("Gestion des groupes")}
                >
                  Gestion des groupes
                </Link>
                {isSuperAdmin && (
                  <Link
                    to="/setting/audit-log"
                    className={`pl-[3.8rem] block menu ${
                      location.pathname === "/setting/audit-log"
                        ? "submenu-active"
                        : ""
                    }`}
                    onClick={() => setTitle("Journal des actions")}
                  >
                    Journal des actions
                  </Link>
                )}
                {(detailsUserConnected?.profil.type === "ADMIN" ||
                  detailsUserConnected?.profil.type === "ADMIN_DRPS") && (
                  <Link
                    to="/setting/interim-agent"
                    className={`pl-[3.8rem] block menu ${
                      location.pathname === "/setting/interim-agent"
                        ? "submenu-active"
                        : ""
                    }`}
                    onClick={() => setTitle("Gestion des agents intérimaires")}
                  >
                    Gestion des intérimaires
                  </Link>
                )}
              </div>
            )}

            {isComplaint && (
              <Link
                to="/complaint/list-complaint"
                className={`pl-6 menu ${
                  location.pathname === "/complaint/list-complaint"
                    ? "menu-active"
                    : ""
                }`}
                onClick={() => {
                  setTitle("Gestion des plaintes");
                  setIsMenuOpen((prev) =>
                    prev === "complaint" ? null : "complaint"
                  );
                }}
              >
                <span className="pr-2">
                  <Plainte
                    color={
                      location.pathname === "/complaint/list-complaint"
                        ? "#086D33"
                        : "#6C757D"
                    }
                  />
                </span>
                Plaintes
              </Link>
            )}
          </nav>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
